import React from 'react';
import styled from 'styled-components';
import useReveal from '../hooks/useReveal';

const Wrap = styled.div`
  opacity: ${(p) => (p.$visible ? 1 : 0)};
  transform: translateY(${(p) => (p.$visible ? 0 : 56)}px);
  transition: opacity 0.9s cubic-bezier(.2,.7,.3,1), transform 0.9s cubic-bezier(.2,.7,.3,1);
  transition-delay: ${(p) => p.$delay || '0s'};
`;

export default function Reveal({ children, delay, style }) {
  const [ref, visible] = useReveal();
  return (
    <Wrap ref={ref} $visible={visible} $delay={delay} style={style}>
      {children}
    </Wrap>
  );
}
